import { useContext } from 'react';
import CarsContext, { ProviderContext } from './CarsContext';

const useCars = (): ProviderContext => useContext(CarsContext)
export default useCars;